import styled from "styled-components";

const PlaylistContainer = styled.div`
  position: relative;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme }) => theme.colors.grey}}
`;

const PlaylistHeader = styled.div`
  width: 100%;
  background: white;
  padding: 16px;
  border-radius: ${(props) =>
    props.isFullVersion ? " 8px 8px 0px 0px" : "8px"};
`;

const PlaylistDetails = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: scroll;
  border-radius: 0px 0px 8px 8px;
  background: white;
`;

export { PlaylistContainer, PlaylistHeader, PlaylistDetails };
